(() => {
  if (window.FoCartPreview) return;
  const dialog = document.querySelector('[data-fo-cart-preview]');
  if (!dialog) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const get = name => dialog.querySelector('[data-fo-cart-' + name + ']');
  let cart, busy = false, returnFocus, oldOverflow, savingsRevision = 0;
  const money = value => new Intl.NumberFormat('de-DE', {style:'currency', currency:cart?.currency || 'EUR'}).format(value / 100);
  const safeUrl = value => { if (!value) return ''; try { const u = new URL(value, location.origin); return ['https:','http:'].includes(u.protocol) ? u.href : ''; } catch { return ''; } };
  const translateMessage = value => {
    const message = String(value || '');
    const limited = message.match(/Only\s+(\d+)\s+items?\s+(?:were|was)\s+added to your cart due to availability\.?/i);
    if (limited) return 'Aufgrund der Verfügbarkeit ' + (Number(limited[1]) === 1 ? 'konnte nur 1 Artikel' : 'konnten nur ' + limited[1] + ' Artikel') + ' deinem Warenkorb hinzugefügt werden.';
    if (/You can(?:not|'t|’t) add more .* to (?:the|your) cart/i.test(message)) return 'Die maximal verfügbare Stückzahl ist bereits im Warenkorb.';
    if (/sold out|out of stock/i.test(message)) return 'Dieser Artikel ist aktuell nicht verfügbar.';
    if (/not available|not enough|quantity|could not|cannot|invalid|maximum|minimum/i.test(message)) return 'Der Warenkorb konnte nicht aktualisiert werden. Prüfe die verfügbare Stückzahl und versuche es erneut.';
    return message;
  };
  const read = async (path, options = {}) => {
    const response = await fetch(root() + path, {...options, headers:{Accept:'application/json', ...(options.headers || {})}, cache:'no-store'});
    const data = await response.json();
    if (!response.ok) {window.FoShopTools?.emit('fo_cart_error',{operation:path,status:response.status});throw Error(translateMessage(data.description) || 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.');}
    return data;
  };
  // Compare-at markdowns are already included in the selling price. Never subtract them again.
  const renderSavings = async data => {
    const revision = ++savingsRevision, row = get('savings');
    row.hidden = true;
    get('savings-amount').textContent = '';
    if (!data.items.length) return;
    try {
      const products = new Map();
      const amounts = await Promise.all(data.items.map(async item => {
        if (!item.handle) throw Error('Missing product handle');
        if (!products.has(item.handle)) products.set(item.handle, read('products/' + encodeURIComponent(item.handle) + '.js'));
        const product = await products.get(item.handle);
        const variant = product.variants?.find(v => String(v.id) === String(item.variant_id));
        if (!variant) throw Error('Missing cart variant');
        const compare = Number(variant.compare_at_price || 0), price = Number(item.original_price), quantity = Number(item.quantity);
        if (![compare, price, quantity].every(Number.isFinite) || price < 0 || !Number.isInteger(quantity) || quantity < 1) throw Error('Invalid cart pricing');
        return Math.max(0, compare - price) * quantity;
      }));
      if (revision !== savingsRevision) return;
      const savings = amounts.reduce((total, amount) => total + amount, 0);
      if (savings > 0) {get('savings-amount').textContent = money(savings); row.hidden = false;}
    } catch (_) { /* Keep the row hidden if the full amount cannot be verified. */ }
  };
  const render = data => {
    document.dispatchEvent(new CustomEvent('fo:cart-render',{detail:data}));
    cart = data;
    renderSavings(data);
    const isEmpty = data.item_count === 0;
    get('empty').hidden = !isEmpty;
    get('items').hidden = isEmpty;
    get('guarantee').hidden = isEmpty;
    get('continue').hidden = isEmpty;
    get('count').hidden = isEmpty;
    get('message').classList.toggle('fo-cart-preview__message--empty', isEmpty);
    get('count').textContent = '(' + data.item_count + ')';
    get('total').textContent = money(data.total_price);
    get('footer').hidden = data.item_count === 0;
    const shipping = get('shipping'), threshold = Number(shipping.dataset.threshold) || 0, eligible = data.currency === 'EUR' && data.item_count > 0 && threshold > 0;
    shipping.hidden = !eligible;
    if (eligible) {
      const remaining = Math.max(0, threshold - data.total_price);
      shipping.classList.toggle('is-earned', remaining === 0);
      get('shipping-text').textContent = remaining ? shipping.dataset.remaining.replace('[amount]', money(remaining)) : shipping.dataset.earned;
      get('progress').max = threshold;
      get('progress').value = Math.min(threshold, Math.max(0, data.total_price));
    }
    get('items').innerHTML = data.items.map(item => {
      const src = safeUrl(item.featured_image?.url || item.image), href = safeUrl(item.url);
      const liveVariant=window.FoShopTools?.products.flatMap(p=>p.variants).find(v=>v.id===String(item.variant_id));
      const variant = liveVariant?.size || (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
      return '<article class="fo-cart-preview__item">' + (src ? '<img src="' + esc(src) + '" alt="' + esc(item.product_title) + '" width="85" height="100">' : '<div></div>') + '<div><a href="' + esc(href) + '">' + esc(item.product_title) + '</a>' + (variant ? '<p class="fo-cart-preview__variant">' + esc(variant) + '</p>' : '') + '<p class="fo-cart-preview__line-price">' + money(item.final_line_price) + '</p><div class="fo-cart-preview__controls"><button type="button" data-fo-cart-key="' + esc(item.key) + '" data-fo-cart-quantity="' + (item.quantity-1) + '" aria-label="Ein Stück weniger: ' + esc(item.product_title) + '">−</button><span aria-label="Anzahl">' + item.quantity + '</span><button type="button" data-fo-cart-key="' + esc(item.key) + '" data-fo-cart-quantity="' + (item.quantity+1) + '" aria-label="Ein Stück mehr: ' + esc(item.product_title) + '">+</button><button type="button" class="fo-cart-preview__remove" data-fo-cart-key="' + esc(item.key) + '" data-fo-cart-quantity="0">Entfernen</button></div></div></article>';
    }).join('');
    get('message').textContent = data.item_count ? '' : dialog.dataset.emptyMessage;
    document.querySelectorAll('.fh-header-cart').forEach(link => {
      link.setAttribute('aria-label', 'Warenkorb, ' + data.item_count + ' Artikel');
      let count = link.querySelector('.fh-cart-count');
      if (!count && data.item_count) {count = document.createElement('span'); count.className = 'fh-cart-count'; count.setAttribute('aria-hidden','true'); link.append(count);}
      if (count) {count.textContent = data.item_count; count.hidden = !data.item_count;}
    });
  };
  const open = async origin => {
    if (!dialog.open) {returnFocus = origin || document.activeElement; oldOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; dialog.showModal();}
    ++savingsRevision; get('savings').hidden = true;
    get('empty').hidden = true;
    get('guarantee').hidden = true;
    get('items').hidden = false;
    get('continue').hidden = false;
    get('message').classList.remove('fo-cart-preview__message--empty');
    get('message').textContent = 'Warenkorb wird geladen …';
    try {render(await read('cart.js'));} catch (error) {get('message').textContent = error.message + ' Du kannst deinen Warenkorb auch über „Warenkorb ansehen“ öffnen.'; get('footer').hidden = false;}
  };
  const requestSize = scope => {
    window.FoShopTools?.emit('fo_size_required',{product_handle:scope.dataset.productHandle||''});
    const field = scope.querySelector('.fo-size-options'), feedback = scope.querySelector('[data-product-size-feedback],[data-fo-preview-feedback]');
    if (feedback) {feedback.textContent = 'Bitte wähle eine Größe aus.'; feedback.classList.add('fo-size-error'); if (!feedback.id) feedback.id = 'fo-required-size-error';}
    if (field) {field.removeAttribute('tabindex'); field.setAttribute('aria-invalid','true'); if (feedback) field.setAttribute('aria-describedby', feedback.id); const choice = field.querySelector('input[type="radio"]:not(:disabled)'); choice?.focus({preventScroll:true}); field.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});}
  };
  const guardQuantity = event => {
    const select = event.target.closest('[data-product-quantity],[data-fo-preview-quantity]');
    if (!select) return;
    if (event.type === 'keydown' && !['Enter',' ','ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
    const scope = select.closest('[data-product-page],[data-fo-preview-page]');
    if (!scope) return;
    const selected = scope.querySelector('[data-product-variant-id]')?.value || scope.querySelector('input[name="fo_preview_size"]:checked')?.value;
    if (selected) return;
    event.preventDefault(); event.stopImmediatePropagation(); requestSize(scope);
  };
  document.addEventListener('pointerdown', guardQuantity, true);
  document.addEventListener('click', guardQuantity, true);
  document.addEventListener('keydown', guardQuantity, true);
  const close = () => dialog.close();
  dialog.addEventListener('close', () => {document.body.style.overflow = oldOverflow || ''; if (returnFocus?.isConnected) returnFocus.focus();});
  dialog.addEventListener('click', async event => {
    if (event.target === dialog) {const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();}
    if (event.target.closest('[data-fo-cart-close]')) close();
    const button = event.target.closest('[data-fo-cart-key]');
    if (!button || busy) return;
    busy = true; const key = button.dataset.foCartKey, nextQuantity = Number(button.dataset.foCartQuantity);
    dialog.querySelectorAll('[data-fo-cart-key]').forEach(b => b.disabled = true);
    ++savingsRevision; get('savings').hidden = true;
    get('message').textContent = 'Warenkorb wird aktualisiert …';
    try {
      render(await read('cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:key, quantity:nextQuantity})}));
      const same = Array.from(dialog.querySelectorAll('[data-fo-cart-key]')).find(b => b.dataset.foCartKey === key);
      (same || get('items').querySelector('a') || (!get('empty').hidden && get('empty').querySelector('a')) || dialog.querySelector('[data-fo-cart-close]')).focus();
    } catch (error) {get('message').textContent = error.message;}
    finally {busy = false; dialog.querySelectorAll('[data-fo-cart-key]').forEach(b => b.disabled = false);}
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('.fh-header-cart');
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {event.preventDefault(); open();}
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-product-page] form.fo-product-form')) return;
    const button = form.querySelector('[data-product-buy]'), id = form.querySelector('[name="id"]')?.value, quantity = Number(form.querySelector('[name="quantity"]')?.value);
    if (form.dataset.cartBusy === 'true') {event.preventDefault(); return;}
    if (!button || button.disabled) return;
    if (!id) {event.preventDefault(); event.stopImmediatePropagation(); requestSize(form.closest('[data-product-page]')); return;}
    if (!Number.isInteger(quantity) || quantity < 1) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const message = form.querySelector('[data-product-cart-feedback]');
    form.dataset.cartBusy = 'true'; button.disabled = true; button.textContent = 'Wird hinzugefügt …';
    if (message) message.hidden = true;
    try {
      await read('cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:Number(id), quantity}]})});
      await open(button);
    } catch (error) {if (message) {message.textContent = error.message; message.hidden = false;}}
    finally {delete form.dataset.cartBusy; button.disabled = false; button.textContent = 'In den Warenkorb';}
  }, true);
  window.FoCartPreview = {open, requestSize, translateMessage};
})();

